import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxQrcodeElementTypes, NgxQRCodeModule } from '@jonyadamit/ngx-qrcode-ivy';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgIf } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'mfa-mobile-registration',
    templateUrl: './mobile-registration.component.html',
    styleUrls: ['./mobile-registration.component.scss'],
    imports: [NgIf, FlexModule, NgxQRCodeModule]
})
export class MobileRegistrationComponent implements OnInit, OnDestroy {
  constructor(private route: ActivatedRoute) {}

  onDestroy$ = new Subject<void>();
  id: string | null = null;
  elementType = NgxQrcodeElementTypes;
  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.onDestroy$)).subscribe((params) => {
      this.id = params.get('id');
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }
}
